// import { VERSION } from '@/version';

// export const checkVersion = () => {
//   const savedVersion = localStorage.getItem('app_version');

//   console.log("VERSION:"+VERSION)
//   console.log("savedVersion:"+savedVersion)

//   if (savedVersion !== VERSION) {
//     localStorage.setItem('app_version', VERSION);
    
//     // 如果是首次加载或版本更新，强制刷新（可选）
//     if (savedVersion) {
//         console.log("清除缓存，更新版本")
//         window.location.reload();
//     }
//   }
// };


import { Modal } from 'ant-design-vue';
import axios from 'axios';

// 检测更新
export const checkVersion = async () => {
  try {
    // 本地版本
    const localVersion = process.env.VUE_APP_VERSION; 
    console.log("localVersion:"+localVersion)

    const { data: remoteVersion } = await axios.get('./version.json?t=' + Date.now());
    console.log("remoteVersion:"+remoteVersion.version)
    if (remoteVersion.version !== localVersion) {
      showUpdateModal();
    }
  } catch (error) {
    console.error('版本检测失败:', error);
  }
};

// 显示弹窗
const showUpdateModal = () => {
    let modal = null;
    
    const destroy = () => {
      if (modal) modal.destroy();
    };
  
    modal = Modal.info({
      title: '发现新版本 🚀',
      content: '系统已更新，请您更新系统后使用',
      okText: '立即更新',
      centered: true,
      maskClosable: false,
      onOk: () => {
        window.location.reload(true);
        destroy();
      }
    });
  };